@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.captions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.caption {
  background: var(--light-100);
  padding: 10px;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;

  &.hovered {
    background: var(--dark-4);
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .captionText {
    @include sm-sohne;
    color: var(--dark-100);
    display: inline;
  }

  .moreLessText {
    @include sm-sohne;
    color: var(--dark-40);
    display: inline;
    white-space: nowrap;
    margin-left: 4px;

    &.hovered {
      cursor: pointer;
      color: var(--selected-fill);
    }
  }
}
